module.exports = __webpack_public_path__ + "img/banner.7097067c.png";